import { makeJobFiltersStateVar, jobFiltersStateVar } from "./jobs"

const resetStateVars = () => {
  jobFiltersStateVar({ ...makeJobFiltersStateVar() })
}

export { resetStateVars }
